import React, { PropsWithChildren, useCallback, useContext, useState } from 'react';
import { Pressable, ScrollView, ScrollViewProps, StyleProp, StyleSheet, View, ViewStyle } from 'react-native';
import { CustomText } from '@/components/CustomText';
import { Text } from 'react95-native-rabbl';
import { Link } from 'expo-router';
import * as AppConstants from '@/utilities/AppConstants';
import * as AppUtilities from '@/utilities/AppUtilities';
import * as AppUtils from '@/utilities/AppUtils';
import { BasicScrollView } from "@/components/BasicScrollView";
import { ExternalLink } from '@/components/ExternalLink';
import { Community, UNKNOWN_COMMUNITY } from "@/types/community";
import { RelativePathString, useRouter } from 'expo-router';
import { setDomain } from '@/state/user';
import { setDrawerOpen } from '@/state/user';
import type { RootState } from '@/state/store';
import { useSelector, useDispatch } from 'react-redux';
import { Image } from 'expo-image';
import { RabblLink } from '@/components/RabblLink';

const styles = StyleSheet.create({
  headerIcon: {
    width: 28,
    height: 28,
  },
});

interface Props {
};

export function RabblHomeButton({ }: Props) : React.ReactNode {
  const isMainLogicalHost = useSelector((state: RootState) => state.user.isMainLogicalHost);
  const loggedIn = useSelector((state: RootState) => state.user.loggedIn);
  const communityMembership = useSelector((state: RootState) => state.user.communityMembership);

  return (
    <Link href={AppUtils.getHomeLink(loggedIn, isMainLogicalHost, communityMembership)} asChild={AppUtilities.isWeb()}>
      <Image source={require('@/assets/images/butterflyicon.png')} style={styles.headerIcon} />
    </Link>
  )
};
